export enum ComponentsEnum {
  TRAINING_LAYOUT = 'training-layout',
  TRAINING_MENU = 'training-menu',
}
